import React from 'react';
import { useFontSize } from '../../contexts/FontSizeContext';
import { getTextSizeClass, getSmallTextSizeClass } from '../../utils/fontSizeUtils';
import { TIMEFRAME_OPTIONS, Timeframe } from '../../utils/dailyPriceUtils';
import { useClickOutside } from '../../hooks/useClickOutside';

interface TimeframeDropdownProps {
  timeframe: Timeframe;
  onTimeframeChange: (timeframe: Timeframe) => void;
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
}

export const TimeframeDropdown: React.FC<TimeframeDropdownProps> = ({
  timeframe,
  onTimeframeChange,
  isOpen,
  onToggle,
  onClose,
}) => {
  const { fontSize } = useFontSize();
  useClickOutside(isOpen, 'timeframe-dropdown', onClose);

  const selectedOption = TIMEFRAME_OPTIONS.find(opt => opt.value === timeframe);

  return (
    <div className="flex items-center space-x-3">
      <label className={`${getTextSizeClass(fontSize)} font-medium text-gray-700 dark:text-text-secondary px-2`}>
        Past
      </label>
      <div className="relative timeframe-dropdown">
        <button
          onClick={onToggle}
          className={`flex items-center gap-2 text-gray-900 dark:text-text-primary bg-white dark:bg-background border border-border-light dark:border-border-color px-3 py-1.5 rounded-md ${getTextSizeClass(fontSize)} font-medium hover:bg-gray-50 dark:hover:bg-border-color`}
        >
          <span>{selectedOption?.label}</span>
          <svg className="w-4 h-4 text-gray-900 dark:text-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M19 9l-7 7-7-7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
          </svg>
        </button>
        {isOpen && (
          <div className="absolute left-0 mt-2 w-32 bg-white dark:bg-background border border-border-light dark:border-border-color rounded-md shadow-lg z-[60] transition-none">
            {TIMEFRAME_OPTIONS.map((option) => (
              <button
                key={option.value}
                onClick={() => {
                  onTimeframeChange(option.value);
                  onClose();
                }}
                className={`block w-full text-left px-3 py-1.5 ${getTextSizeClass(fontSize)} ${
                  timeframe === option.value
                    ? 'text-gray-900 dark:text-text-primary bg-highlight-gold/10 dark:bg-highlight-gold/20 font-semibold'
                    : 'text-gray-700 dark:text-text-primary hover:bg-gray-100 dark:hover:bg-border-color'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

